import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "jobs-panel-list-item__header" }
const _hoisted_2 = { class: "jobs-panel-list-item__header-workers" }
const _hoisted_3 = { class: "jobs-panel-list-item__header-worker" }
const _hoisted_4 = { class: "jobs-panel-list-item__header-divider" }
const _hoisted_5 = { class: "jobs-panel-list-item__header-worker" }
const _hoisted_6 = { class: "jobs-panel-list-item__body" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "jobs-panel-list-item__footer" }
const _hoisted_9 = { class: "jobs-panel-list-item__footer-bottom" }
const _hoisted_10 = { class: "jobs-panel-list-item__footer-bottom-created" }

import { i18n } from "@/i18n";
import { computed, ref } from "vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import { Job, jobsStore } from "@/store/jobs";
import { JobStatus } from "@/models/etc/types";
import { getJobDeadlineState } from "@/utils/jobDeadline";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'FileJobElement',
  props: {
    job: {}
  },
  emits: ["select-job"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = jobsStore();
const isLoading = ref(false);

const onCardClick = () => {
  emit("select-job", props.job);
};

const showCreatorName = computed(
  () => !!props.job.Creator && props.job.Creator.Id !== props.job.Worker?.Id
);

const getJobStatusBarColor = (status: JobStatus) => {
  switch (status) {
    case JobStatus.Standard:
      return "#9A9C9E";
    case JobStatus.Working:
      return "#86CED2";
    case JobStatus.WaitingForCheck:
      return "#FFE7AA";
    case JobStatus.Completed:
      return "#6DA279";
    case JobStatus.Lost:
      return "#EE966A";
  }
};

const toDate = (date?: string | Date) => {
  if (!date) {
	return null;
  }
  return typeof date === "string" ? new Date(date) : date;
};

const formatDate = (date?: string | Date) => {
  const dateObj = toDate(date);
  if (!dateObj) {
	return "";
  }

  return dateObj.toLocaleDateString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  });
};

const formatTimeDate = (date?: string | Date) => {
  const dateObj = toDate(date);
  if (!dateObj) {
    return "";
  }

  const hours = String(dateObj.getHours()).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes} ${formatDate(dateObj)}`;
};

const loaderStyle = computed(() => ({
  "background-color": "rgba(255, 255, 255, 0.5)",
}));

const dateState = computed(() => getJobDeadlineState(props.job));
const isDateLost = computed(() => dateState.value === "lost");
const isDateSuccess = computed(() => dateState.value === "success");

const dateTooltip = computed(() => {
  if (!props.job.CompletionDate) {
    return String(i18n.global.t('job_deadline'));
  }
  // У завершённой работы на месте срока показана дата завершения, поэтому
  // исходный срок выносим в тултип
  return isDateLost.value
    ? String(i18n.global.t('job_overdue_at', { date: formatDate(props.job.ToDoDate) }))
    : String(i18n.global.t('job_state_completed'));
});

const additionsExpanded = ref(false);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: "$job",
    class: _normalizeClass({
      'jobs-panel-list-item': true,
    }),
    onClick: onCardClick
  }, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(AppLoader, {
          key: 0,
          style: _normalizeStyle(loaderStyle.value)
        }, null, 8, ["style"]))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createElementVNode("div", {
      class: _normalizeClass({
        'jobs-panel-list-item__drop-zone': true,
      })
    }, null, -1)),
    _createElementVNode("div", {
      class: "jobs-panel-list-item__colored",
      style: _normalizeStyle({ backgroundColor: getJobStatusBarColor(props.job.Status) })
    }, null, 4),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(props.job.Worker.Name), 1),
        (showCreatorName.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(AppIcon, {
                  class: "jobs-panel-list-item__header-options-btn",
                  name: "chevron-left",
                  width: "16px",
                  color: "#499259"
                })
              ]),
              _createElementVNode("div", _hoisted_5, _toDisplayString(props.job.Creator.Name), 1)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: "jobs-panel-list-item__body-message",
        innerHTML: props.job.Message
      }, null, 8, _hoisted_7)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(AppTooltip, { text: dateTooltip.value }, {
          activator: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass({
                'jobs-panel-list-item__footer-bottom-date': true,
                'jobs-panel-list-item__footer-bottom-date--lost': isDateLost.value,
                'jobs-panel-list-item__footer-bottom-date--success': isDateSuccess.value,
              })
            }, [
              _createVNode(AppIcon, {
                class: "jobs-panel-list-item__footer-bottom-date-clock",
                name: "clock",
                width: "16px"
              }),
              (props.job.CompletionDate)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(formatTimeDate(props.job.CompletionDate)), 1)
                  ], 64))
                : (props.job.ToDoDate)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(formatDate(props.job.ToDoDate)), 1)
                    ], 64))
                  : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        }, 8, ["text"]),
        _createElementVNode("span", _hoisted_10, _toDisplayString(formatTimeDate(props.job.CreateTime)), 1)
      ])
    ])
  ], 512))
}
}

})